import * as ActionTypes from '../constants/ActionType'

export const setUrl = url => {
  return {
    type: ActionTypes.SET_SIDEBAR,
    payload: url
  }
}
